<template>
	<v-btn :color="color" :disabled="disabled" @click="handleClick" variant="text" class="square-btn no-focus" :style="buttonStyle">
		<v-icon :size="size" :color="iconColor">{{ icon }}</v-icon>
	</v-btn>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';

export default defineComponent({
	name: 'IconButton',
	props: {
		icon: { type: String, required: true },
		size: { type: [Number, String], default: 24 }, // icon size
		buttonSize: { type: [Number, String], default: 48 }, // square button size
		color: { type: String, default: 'grey lighten-2' }, // button background
		iconColor: { type: String, default: 'primary' }, // icon color
		disabled: { type: Boolean, default: false },
	},
	emits: ['click'],
	setup(props, { emit }) {
		const handleClick = (event: MouseEvent) => {
			if (!props.disabled) emit('click', event);
		};

		// CSS variable for dynamic button size
		const buttonStyle = computed(() => ({
			'--btn-size': typeof props.buttonSize === 'number' ? props.buttonSize + 'px' : props.buttonSize,
		}));

		return { handleClick, buttonStyle };
	},
});
</script>

<style scoped>
.square-btn {
	width: var(--btn-size);
	height: var(--btn-size);
	min-width: var(--btn-size) !important;
	padding: 4px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgba(245, 245, 245, 1);
}

/* Remove focus outline */
.no-focus:focus {
	outline: none;
	box-shadow: none;
}
</style>
